// The capture signal for the application (addendum §4 H4). D0's index.html resolver reads `?capture&theme=` from the
// query before the hash and sets html[data-capture] and html[data-theme] before paint, without touching the stored
// theme; D0's McRoot reads the same attribute. This module reads it too, so there is one source of truth: it never
// parses location.search, and it emits no hotspot (D0's useHs does, from string keys, H1–H2).

/** True on a page opened with `?capture` (a walk photographing a frame). */
export function isCapture(): boolean {
  return typeof document !== "undefined" && document.documentElement.hasAttribute("data-capture");
}

/** The theme the capture page was opened in (html[data-theme]), or null outside a resolved theme. */
export function captureTheme(): "light" | "dark" | null {
  if (typeof document === "undefined") return null;
  const theme = document.documentElement.getAttribute("data-theme");
  return theme === "light" || theme === "dark" ? theme : null;
}
